import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { COMMON_ERROR } from 'utils/ErrorMessages'

import { addToast } from 'containers/Toasts/actions'

import { fetchData as fetchMailboxes } from '../actions'
import { selectTypeFilter } from '../selectors'

import { removeTagError, removeTagSuccess, toggleStatusError, toggleStatusSuccess } from './actions'
import { STATUS_TOGGLE_ASYNC, TAG_REMOVE_ASYNC } from './constants'

const toggleStatusEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(STATUS_TOGGLE_ASYNC.INITIATE).mergeMap((action) =>
    api.mailboxes
      .toggleStatus(
        store.getState().partnerOptions.selectedCompany?.value,
        action.payload.id,
        action.payload.status
      )
      .mergeMap(({ response }) => {
        const typeFilter = selectTypeFilter(store.getState())
        // we want to dispatch a fetching because we want to show only enabled or disabled mailboxes
        if (typeFilter === 'enabled' || typeFilter === 'disabled') {
          // without timeout the loader will unmount the tableRow and cancel this call
          setTimeout(() => store.dispatch(fetchMailboxes()), 1000)
        }
        if (response.success) {
          return Observable.of(toggleStatusSuccess(response))
        } else
          return Observable.of(
            toggleStatusSuccess(response),
            addToast({
              message: response.message,
              type: 'error',
            })
          )
      })
      .catch((error) =>
        Observable.of(
          epicsErrorHandler(toggleStatusError, error),
          addToast({
            message: COMMON_ERROR,
            type: 'error',
          })
        )
      )
      .takeUntil(action$.ofType(STATUS_TOGGLE_ASYNC.CANCEL))
  )

const tagRemoveEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(TAG_REMOVE_ASYNC.INITIATE).mergeMap((action) =>
    api.mailboxes
      .removeTags(store.getState().partnerOptions.selectedCompany?.value, {
        profileIds: [action.payload.id],
        tagNames: [action.payload.tagName],
        oneTagMode: true,
      })
      .map(({ response }) => {
        store.dispatch(fetchMailboxes())
        return removeTagSuccess(response)
      })
      .catch((error) => Observable.of(epicsErrorHandler(removeTagError, error)))
  )

export default combineEpics(toggleStatusEpic, tagRemoveEpic)
